import QRCode from 'qrcode';

/**
 * Generate a QR code as a PNG data URL, fully client-side (the `qrcode`
 * package renders offline — the link never leaves the browser to a third-party
 * QR service). Used for the shareable NPS links.
 */
export async function qrDataUrl(text: string): Promise<string> {
  return QRCode.toDataURL(text, {
    width: 512,
    margin: 2,
    errorCorrectionLevel: 'M',
    color: { dark: '#0f172a', light: '#ffffff' },
  });
}
